import React, { useState } from 'react'
import { Grid } from '@mui/material'
import Box from '@mui/material/Box';
import { FormControl, TextField, Typography } from '@mui/material';
import dayjs from 'dayjs';
import ApiClient from '../../common/ApiClient';
import { useEffect } from 'react';
import DeleteDialog from '../../ip/DeleteDialog';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { GLOBAL_URL } from '../../../API/global';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { validatePdf } from '../../Helper';
import { useParams } from 'react-router-dom';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const PartnalnfoSingle = ({ formData, setFormData, errors, setProducerErrors }) => {
    const { id = null } = useParams();
    const { postRequest, getRequest, deleteRequest } = ApiClient();
    const [selectedIncorporationRegistration, setSelectedIncorporationRegistration] = useState(null);
    const [openRequisiteDocumentsopen, setOpenRequisiteDocumentsopen] = React.useState(false);

    const [open, setOpen] = React.useState(false);
    const [openSingleForm, setOpenSingleForm] = React.useState(false);
    const [openBlueray, setOpenBlueray] = React.useState(false);
    const [openProduction, setOpenProduction] = React.useState(false);
    const [openEachEpisodeDuration, setOpenEachEpisodeDuration] = React.useState(false);
    const [openCoProducerDetails, setOpenCoProducerDetails] = React.useState(false);
    const [openProducerSingle, setOpenProducerSingle] = React.useState(false);
    const [openOriginalProduction, setOpenOriginalProduction] = React.useState(false);
    const [openInformationBroadcasting, setOpenInformationBroadcasting] = React.useState(false);
    const [openEachIndividualProducer, setOpenEachIndividualProducer] = React.useState(false);
    const [preData, setPreData] = useState([]);
    const [isNoDisabled, setIsNoDisabled] = useState(false);
    const loadData = async () => {
        const preData = await getRequest(`ott/${id}/coproducer`);
        const data = preData.data;

        if (data.length > 0) {
            setFormData({
                ...formData,

            });
            setProducerErrors({
                ...errors,

            })

            setIsNoDisabled(false);
        } else {
            setFormData({
                ...formData,

            });
            setIsNoDisabled(true);
        }
        //  if (data && data.length < 5) setShowAddNewEntry(true)
        setPreData(data);
    }
    useEffect(() => {
        loadData();

    }, []);

    const handleFormData = (e) => {
        const { name, value } = e.target;


        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
        errors[name] = ""
        setProducerErrors(errors);
        const newValue = value.replace(/\D/g, '').slice(0, 10);
        if (name == "coproducer_phone") {
            setFormData(prevData => ({
                ...prevData,
                [name]: newValue
            }));
        } else {
            setFormData(prevData => ({
                ...prevData,
                [name]: value
            }));
        }

        if (name === 'coproducer_email') {
            validateProducerEmail(value);
        }

    };

    const handleFormDataSingle = (e) => {
        const { name, value } = e.target;

        if (value === 0 || value === "0") {
            setOpenSingleForm(true);
            setFormData({
                ...formData,
                [name]: parseInt(value),
            })
        } else {
            setFormData({
                ...formData,
                [name]: parseInt(value),
            });
            errors[name] = ""
            setProducerErrors(errors);
        }

    };

    const handleProductionChange = (e) => {
        const { name, value } = e.target;

        if (value === 0 || value === "0") {
            setOpenProduction(true);
            setFormData({
                ...formData,
                [name]: parseInt(value),
            })
        } else {
            setFormData({
                ...formData,
                [name]: parseInt(value),
            });
            errors[name] = ""
            setProducerErrors(errors);
        }
    }


    // console.log(formData)

    const validateProducerEmail = (email) => {
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        if (!emailRegex.test(email)) {
            setProducerErrors({
                ...errors,
                coproducer_email: 'Invalid email format'
            });
        } else {
            setProducerErrors({
                ...errors,
                coproducer_email: ''
            });
        }
    };
    const handleKeyDown = (event) => {
        // Prevent the letter 'e', '+', '-', '.' and other non-numeric characters
        if (['e', 'E', '+', '-', '.'].includes(event.key)) {
            event.preventDefault();
        }
    };

    const handleSelectedIncorporationRegistrationIndia = (event) => {

        const selectedFile = event.target.files[0];
        const validateState = validatePdf(selectedFile);

        if (!validateState['status']) {
            setProducerErrors({
                incorporation_registration_in_india: validateState.message
            })
        } else {
            setSelectedIncorporationRegistration(event.target.files[0]);
            // console.log("incorporation registration")
            const profileOfIncorporationRegistration = event.target.files[0];
            // console.log(profileOfIncorporationRegistration);
            // console.log("Selected Director file:", selectedDirectorFile);
            setFormData((prevState) => ({
                ...prevState,
                incorporation_registration_in_india: profileOfIncorporationRegistration,
                is_incorporation_registration_in_india: 1,
            }));
            setProducerErrors({
                incorporation_registration_in_india: ''
            })
        }


    };

    const handleSelectedIncorporationRegistrationForiegn = (event) => {

        const selectedFile = event.target.files[0];
        const validateState = validatePdf(selectedFile);

        if (!validateState['status']) {
            setProducerErrors({
                incorporation_registration_in_foreign: validateState.message
            })
        } else {
            setSelectedIncorporationRegistration(event.target.files[0]);
            // console.log("incorporation registration")
            const profileOfIncorporationRegistrationForiegn = event.target.files[0];
            // console.log(profileOfIncorporationRegistration);
            // console.log("Selected Director file:", selectedDirectorFile);
            setFormData((prevState) => ({
                ...prevState,
                incorporation_registration_in_foreign: profileOfIncorporationRegistrationForiegn,
                is_incorporation_registration_in_foreign: 1,
            }));
            setProducerErrors({
                incorporation_registration_in_foreign: ''
            })
        }


    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleRequisiteDocumentsClickOpen = () => {
        setOpenRequisiteDocumentsopen(true);
    };

    const handleCloseBlueray = () => {
        setOpenBlueray(false)
    }

    const handleCloseProduction = () => {
        setOpenProduction(false)
    }

    const handleCloseCoProducer = () => {
        setOpenCoProducerDetails(false)
    }

    const handleCoProducer = (e) => {
        const { name, value } = e.target;

        if (value == 1) {
            setOpenCoProducerDetails(true);
            setFormData({
                ...formData,
                [name]: value,
            })
        } else {
            setFormData({
                ...formData,
                [name]: parseInt(value),
            });
            errors[name] = ""
            setProducerErrors(errors);
        }
    }

    const handleCloseProducerSingle = () => {
        setOpenProducerSingle(false)
    }

    const handleSingleProducer = (e) => {
        const { name, value } = e.target;

        if (value == 1) {
            setOpenProducerSingle(true);
            setFormData({
                ...formData,
                [name]: value
            })
        } else {
            setFormData({
                ...formData,
                [name]: parseInt(value),
            });
            errors[name] = ""
            setProducerErrors(errors);
        }
    }

    const handleCloseOriginalProduction = () => {
        setOpenOriginalProduction(false)
    }

    const handleOriginalProduction = (e) => {
        const { name, value } = e.target;

        if (value === 0 || value === "0") {
            setOpenOriginalProduction(true);
            setFormData({
                ...formData,
                [name]: null,
            })
        } else {
            setFormData({
                ...formData,
                [name]: parseInt(value),
            });
            errors[name] = ""
            setProducerErrors(errors);
        }
    }

    const handleCloseBroadcasting = () => {
        setOpenInformationBroadcasting(false)
    }

    const handleInformationBroadcasting = (e) => {
        const { name, value } = e.target;

        if (value === 0 || value === "0") {
            setOpenInformationBroadcasting(true);
            setFormData({
                ...formData,
                [name]: null,
            })
        } else {
            setFormData({
                ...formData,
                [name]: parseInt(value),
            });
            errors[name] = ""
            setProducerErrors(errors);
        }
    }


    const handleCloseEachIndividualProducer = () => {
        setOpenEachIndividualProducer(false)
    }


    const handleEachIndividualProducer = (e) => {
        const { name, value } = e.target;

        if (value === 0 || value === "0") {
            setOpenEachIndividualProducer(true);
            setFormData({
                ...formData,
                [name]: parseInt(value),
            })
        } else {
            setFormData({
                ...formData,
                [name]: parseInt(value),
            });
            errors[name] = ""
            setProducerErrors(errors);
        }
    }
    let placeholdername = "(vi.i) Upload proof of the incorporation/registration/ in India";

    if (formData.coproducer_type == 3 && formData.coproducer_is_residing_in_country) {
        placeholdername = "(vi.i) Upload proof of the individual in India";
    }


    return (
        <>

            <Grid item xs={12} sm={12} md={12} lg={12}>

                <div>
                    <h6>(c) Please fill information of any one as applicable:<span style={{ color: 'red' }}>*</span></h6>


                    {/* <React.Fragment> */}
                    <div className="form-check form-check-inline">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="coproducer_type"
                            id="type_one"
                            value="1"
                            checked={formData.coproducer_type == 1}
                            onChange={handleFormData}
                        // onChange={handleSingleProducer}


                        />
                        <label className="form-check-label" htmlFor="type_one">
                            OTT
                        </label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="coproducer_type"
                            id="type_two"
                            value="2"
                            checked={formData.coproducer_type == 2}
                            onChange={handleFormData}
                        />
                        <label className="form-check-label" htmlFor="type_two">
                            Production House(s)
                        </label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="coproducer_type"
                            id="type_three"
                            value="3"
                            checked={formData.coproducer_type == 3}
                            onChange={handleFormData}
                        />
                        <label className="form-check-label" htmlFor="type_three">
                            Individual Producer(s)
                        </label>
                    </div>
                    {errors.coproducer_type && (
                        <p className="text-danger">{errors.coproducer_type}</p>
                    )}
                    {/* <BootstrapDialog
                                    onClose={handleCloseProducerSingle}
                                    aria-labelledby="customized-dialog-title"
                                    open={openProducerSingle}
                                >
                                    <DialogContent dividers>
                                        <Typography gutterBottom>
                                        Only original production can be submitted
                                        </Typography>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button autoFocus onClick={handleCloseProducerSingle}>
                                            Okay
                                        </Button>
                                    </DialogActions>
                                </BootstrapDialog>
                            </React.Fragment> */}

                </div>



            </Grid>
           



            <Grid item xs={12} sm={12} md={12} lg={12}  >
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>

                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} className='d-flex justify-content-end'>
                        <Box className='d-flex align-items-center'>
                            <Box>

                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <Box>
                    <TextField
                        fullWidth

                        label={
                            <span>
                                (i) Name<span style={{ color: 'red' }}>*</span>
                            </span>
                        }
                        className="input_border"
                        name="coproducer_name"
                        value={formData.coproducer_name}
                        onChange={handleFormData}
                    />
                </Box>
                {errors.coproducer_name && (
                    <p className="text-danger">{errors.coproducer_name}</p>
                )}
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6}>
                {/* <textarea class="form-control"
                    value={formData.coproducer_address}
                    onChange={handleFormData} placeholder="Address" id="floatingTextarea2"
                    style={{
                        height: "100px",
                        borderRadius: "5px"
                    }}
                    name="coproducer_address">
                </textarea> */}
                <Box>
                    <TextField
                        id="coproducer_address"

                        label={
                            <span>
                                (ii) Address<span style={{ color: 'red' }}>*</span>
                            </span>
                        }
                        multiline
                        fullWidth
                        // maxRows={4}
                        name="coproducer_address"
                        value={formData.coproducer_address}
                        onChange={handleFormData}
                    />

                </Box>
                {errors.coproducer_address && (
                    <p className="text-danger">{errors.coproducer_address}</p>
                )}
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <Box className='d-flex align-items-center'>
                    <TextField
                        type='number'
                        fullWidth

                        label={
                            <span>
                                (iii) Phone<span style={{ color: 'red' }}>*</span>
                            </span>
                        }
                        className="input_border"
                        name="coproducer_phone"
                        value={formData.coproducer_phone}
                        inputProps={{ maxLength: 10 }}
                        onChange={handleFormData}
                        onKeyDown={handleKeyDown}
                    />
                </Box>
                {errors.coproducer_phone && (
                    <p className="text-danger">{errors.coproducer_phone}</p>
                )}
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                    fullWidth

                    label={
                        <span>
                            (iv) E-mail<span style={{ color: 'red' }}>*</span>
                        </span>
                    }
                    className="input_border"
                    name="coproducer_email"
                    value={formData.coproducer_email}
                    onChange={handleFormData}
                />
                {errors.coproducer_email && (
                    <p className="text-danger">{errors.coproducer_email}</p>
                )}
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                    fullWidth
                    label="(v) Website (Optional)"
                    name="coproducer_website"
                    value={formData.coproducer_website}
                    onChange={handleFormData}
                />
            </Grid>
             
            {
                (formData.coproducer_type == 1) ?
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Box>

                            {/* <h6>The OTT platform must have furnished information to the Ministry in accordance
                            with Rule 18 of the IT Rules, 2021</h6> */}
                            <h6>(vi) Whether the OTT Platform has furnished information under Rule 18 of IT Rules, 2021 to the Ministry of Information and Broadcasting, Government in India <span style={{ color: 'red' }}>*</span></h6>

                            <React.Fragment>
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="coproducer_is_follow_it_rules"
                                        id="coproducer_is_follow_it_rules_yes"
                                        value="1"
                                        checked={formData.coproducer_is_follow_it_rules == 1}
                                        onChange={handleFormData}

                                    />
                                    <label className="form-check-label" htmlFor="coproducer_is_follow_it_rules_yes">
                                        Yes
                                    </label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="coproducer_is_follow_it_rules"
                                        id="coproducer_is_follow_it_rules_no"
                                        value="0"
                                        checked={formData.coproducer_is_follow_it_rules === 0 || formData.coproducer_is_follow_it_rules === "0"}
                                        // onChange={handleFormData}
                                        onChange={handleInformationBroadcasting}
                                    />
                                    <label className="form-check-label" htmlFor="coproducer_is_follow_it_rules_no">
                                        No
                                    </label>

                                </div>
                                {errors.coproducer_is_follow_it_rules && (
                                    <p className="text-danger">{errors.coproducer_is_follow_it_rules}</p>
                                )}
                                <BootstrapDialog
                                    onClose={handleCloseBroadcasting}
                                    aria-labelledby="customized-dialog-title"
                                    open={openInformationBroadcasting}
                                >
                                    <DialogContent dividers>
                                        <Typography gutterBottom>
                                            OTT Platform should be furnished information under Rule 18 of IT Rules.
                                        </Typography>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button autoFocus onClick={handleCloseBroadcasting}>
                                            Ok
                                        </Button>
                                    </DialogActions>
                                </BootstrapDialog>

                            </React.Fragment>

                        </Box>
                    </Grid>
                    : <></>
            }
            {
                (formData.coproducer_type == 1) ?
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Box>
                            <h6>(vii) Whether the Web Series is its original production <span style={{ color: 'red' }}>*</span></h6>
                            <React.Fragment>
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="coproducer_is_original_production"
                                        id="coproducer_is_original_production_yes"
                                        value="1"
                                        checked={formData.coproducer_is_original_production == 1}
                                        onChange={handleFormData}
                                    />
                                    <label className="form-check-label" htmlFor="coproducer_is_original_production_yes">
                                        Yes
                                    </label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="coproducer_is_original_production"
                                        id="coproducer_is_original_production_no"
                                        value="0"
                                        checked={formData.coproducer_is_original_production === 0 || formData.coproducer_is_original_production === "0"}
                                        // onChange={handleFormData}
                                        onChange={handleOriginalProduction}


                                    />
                                    <label className="form-check-label" htmlFor="coproducer_is_original_production_no">
                                        No
                                    </label>

                                </div>
                                {errors.coproducer_is_original_production && (
                                    <p className="text-danger">{errors.coproducer_is_original_production}</p>
                                )}
                                <BootstrapDialog
                                    onClose={handleCloseOriginalProduction}
                                    aria-labelledby="customized-dialog-title"
                                    open={openOriginalProduction}
                                >
                                    <DialogContent dividers>
                                        <Typography gutterBottom>
                                            Only original production can be submitted.
                                        </Typography>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button autoFocus onClick={handleCloseOriginalProduction}>
                                            Ok
                                        </Button>
                                    </DialogActions>
                                </BootstrapDialog>


                            </React.Fragment>

                        </Box>
                    </Grid>
                    : <></>
            }


            {
                (formData.coproducer_type == 2) ?
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <div>
                            <h6>(vi) Whether the Production House is incorporated/registered in India </h6>

                        </div>
                        <React.Fragment>
                            <div>

                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="coproducer_is_registered"
                                        id="coproducer_is_registered_yes"
                                        value="1"
                                        checked={formData.coproducer_is_registered == 1}
                                        onChange={handleProductionChange}
                                    />
                                    <label className="form-check-label" htmlFor="coproducer_is_registered_yes">
                                        Yes
                                    </label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="coproducer_is_registered"
                                        id="coproducer_is_registered_no"
                                        value="0"
                                        checked={formData.coproducer_is_registered === 0 || formData.coproducer_is_registered === "0"}
                                        onChange={handleProductionChange}
                                        onClick={handleRequisiteDocumentsClickOpen}
                                    />
                                    <label className="form-check-label" htmlFor="coproducer_is_registered_no">
                                        No
                                    </label>

                                </div>
                                {errors.coproducer_is_registered && (
                                    <p className="text-danger">{errors.coproducer_is_registered}</p>
                                )}
                            </div>
                            {/* <BootstrapDialog
                                onClose={handleCloseProduction}
                                aria-labelledby="customized-dialog-title"
                                open={openProduction}
                            >
                                <DialogContent dividers>
                                    <Typography gutterBottom>
                                        Only Production House(s) incorporated/ registered in India can apply
                                    </Typography>
                                </DialogContent>
                                <DialogActions>
                                    <Button autoFocus onClick={handleCloseProduction}>
                                        Ok
                                    </Button>
                                </DialogActions>
                            </BootstrapDialog> */}
                        </React.Fragment>
                    </Grid>
                    : <></>
            }
            {
                (
                    (formData.coproducer_type == 1 && formData.coproducer_is_follow_it_rules == 1) ||
                    (formData.coproducer_type == 2 && formData.coproducer_is_registered == 1) ||
                    (formData.coproducer_type == 3 && formData.coproducer_is_residing_in_country)
                )


                    ?



                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Box>
                            <input
                                type="file"
                                accept=".pdf"
                                onChange={handleSelectedIncorporationRegistrationIndia}
                                style={{ display: 'none', width: "100%" }}
                                id="incorporation"
                                name="incorporation_registration_in_india"
                            />
                            <label htmlFor="incorporation" style={{ width: "100%", height: "100%" }}>

                                <TextField
                                    variant="outlined"
                                    placeholder={placeholdername}
                                    value={selectedIncorporationRegistration ? selectedIncorporationRegistration.name : ''}
                                    InputProps={{
                                        readOnly: true,
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => document.getElementById('incorporation').click()}
                                                    edge="end"
                                                >
                                                    <AttachFileIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                        style: {
                                            // border: "1px solid #1c5768",
                                            borderRadius: "5px",
                                            height: "108px",
                                        },
                                    }}
                                    fullWidth
                                />
                                {errors.incorporation_registration_in_india && (
                                    <p className="text-danger">{errors.incorporation_registration_in_india}</p>
                                )}
                                {!(formData?.documentData?.[5]) ? <></> : (
                                    <div>
                                        <span className="Attach_Photo_ID">
                                            <a href={`${GLOBAL_URL}downloadfile/ott/${formData.id}/${formData?.documentData?.[5].file}`}>{formData?.documentData?.[5].name}</a>
                                        </span>
                                    </div>
                                )}
                            </label>
                        </Box>
                    </Grid>
                    : <></>
            }

            {
                (formData.coproducer_type == 2 && formData.coproducer_is_registered == 0) ?
                    <>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <Box>
                                <TextField
                                    type="text"
                                    fullWidth
                                    label="(vi.i) Please mention the country"
                                    value={formData.nationality}
                                    onChange={handleFormData}
                                    className="input_border"
                                    name="nationality"
                                />
                                {errors.nationality && (
                                    <p className="text-danger">{errors.nationality}</p>
                                )}
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <Box>
                                <input
                                    type="file"
                                    accept=".pdf"
                                    onChange={handleSelectedIncorporationRegistrationForiegn}
                                    style={{ display: 'none', width: '100%' }}
                                    id="incorporationforiegn"
                                    name="incorporation_registration_in_foreign"
                                />
                                <label htmlFor="incorporationforiegn" style={{ width: '100%', height: '100%' }}>
                                    <TextField
                                        variant="outlined"
                                        placeholder="(vi.ii) Upload proof of the PDF"
                                        value={selectedIncorporationRegistration ? selectedIncorporationRegistration.name : ''}
                                        InputProps={{
                                            readOnly: true,
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => document.getElementById('incorporationforiegn').click()}
                                                        edge="end"
                                                    >
                                                        <AttachFileIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                            style: {
                                                borderRadius: '5px',
                                                height: '108px',
                                            },
                                        }}
                                        fullWidth
                                    />
                                    {errors.incorporation_registration_in_foreign && (
                                        <p className="text-danger">{errors.incorporation_registration_in_foreign}</p>
                                    )}
                                    {formData?.documentData?.[7] && (
                                        <div>
                                            <span className="Attach_Photo_ID">
                                                <a href={`${GLOBAL_URL}downloadfile/ott/${formData.id}/${formData?.documentData?.[7].file}`}>
                                                    {formData?.documentData?.[7].name}
                                                </a>
                                            </span>
                                        </div>
                                    )}
                                </label>
                            </Box>
                        </Grid>
                    </>
                    : <></>
            }

            {
                (formData.coproducer_type == 3) ?
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <div>
                            <h6>(vi) Whether the Individual Producer is normally working and residing in India</h6>
                            <React.Fragment>
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="coproducer_is_residing_in_country"
                                        id="coproducer_is_residing_in_country_yes"
                                        value="1"
                                        checked={formData.coproducer_is_residing_in_country == 1}
                                        onChange={handleFormData}

                                    />
                                    <label className="form-check-label" htmlFor="coproducer_is_residing_in_country_yes">
                                        Yes
                                    </label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="coproducer_is_residing_in_country"
                                        id="coproducer_is_residing_in_country_no"
                                        value="0"
                                        disabled={isNoDisabled}
                                        checked={formData.coproducer_is_residing_in_country === 0 || formData.coproducer_is_residing_in_country === "0"}
                                        // onChange={handleFormData}
                                        onChange={handleEachIndividualProducer}
                                    />
                                    <label className="form-check-label" htmlFor="coproducer_is_residing_in_country_no">
                                        No
                                    </label>
                                </div>
                                {errors.coproducer_is_residing_in_country && (

                                    <p className="text-danger">{errors.coproducer_is_residing_in_country}</p>
                                )}
                                {/* <BootstrapDialog
                                    onClose={handleCloseEachIndividualProducer}
                                    aria-labelledby="customized-dialog-title"
                                    open={openEachIndividualProducer}
                                >
                                    <DialogContent dividers>
                                        <Typography gutterBottom>
                                            Individual Producer must be an Indian.
                                        </Typography>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button autoFocus onClick={handleCloseEachIndividualProducer}>
                                            Ok
                                        </Button>
                                    </DialogActions>
                                </BootstrapDialog> */}
                            </React.Fragment>

                        </div>

                    </Grid>
                    : <></>
            }
            {
                (formData.coproducer_type == 3 && formData.coproducer_is_residing_in_country == 0) ?
                    <>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <Box>
                                <TextField
                                    type="text"
                                    fullWidth
                                    label="(vi.i) Please mention the country"
                                    value={formData.nationality}
                                    onChange={handleFormData}
                                    className="input_border"
                                    name="nationality"
                                />
                                {errors.nationality && (
                                    <p className="text-danger">{errors.nationality}</p>
                                )}
                            </Box>
                        </Grid>

                        

                    </>
                    : <></>
            }

            <Grid item xs={12} sm={12} md={12} lg={12} className='mt-3'>
                {/* <Typography className='text-danger text-capitalize'>Note:</Typography> */}
                {/* <Typography className='text-danger text-capitalize'>1.Please Save and Submit The Entries Of Each Type Individually After Filling The Data</Typography> */}
                <Typography className='text-danger'>Note: The name of the OTT Platform/producer(s)/production house(s)/co-producer(s) will be credited as declared in the application form. No request for the change of names would be entertained at any stage.</Typography>
            </Grid>

        </>
    )

}

export default PartnalnfoSingle